import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, createVNode as _createVNode, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { id: "modais" }
const _hoisted_2 = {
  class: "modal fade",
  id: "modalUploadProdutos",
  tabindex: "-1",
  role: "dialog",
  "aria-labelledby": "exampleModalCenterTitle",
  "aria-hidden": "true"
}
const _hoisted_3 = {
  class: "modal-dialog modal-xl modal-dialog-centered",
  role: "document"
}
const _hoisted_4 = {
  class: "modal-content",
  style: {"border-radius":"10px","padding":"20px"}
}
const _hoisted_5 = {
  class: "modal-header",
  style: {"padding-left":"0px"}
}
const _hoisted_6 = { class: "d-flex flex-column gap-4" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("h5", {
  class: "modal-title titulo",
  id: "exampleModalLongTitle",
  style: {"font-size":"20px","padding":"0px"}
}, " Meus produtos ", -1)
const _hoisted_8 = { style: {"color":"red","font-size":"0.9rem","padding":"0px"} }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("button", {
  class: "btn-close",
  type: "button",
  "data-bs-dismiss": "modal",
  "aria-label": "Close"
}, null, -1)
const _hoisted_10 = {
  class: "col-12 row m-0 p-0",
  style: {"gap":"0.75rem"}
}
const _hoisted_11 = { class: "row d-flex flex-row justify-content-between p-0 m-0 gap-3 lista" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("span", null, "Código produto", -1)
const _hoisted_13 = /*#__PURE__*/_createElementVNode("span", { style: {"color":"red","font-size":"0.7rem","padding":"0px"} }, "Código inválido", -1)
const _hoisted_14 = /*#__PURE__*/_createElementVNode("span", null, "Descrição", -1)
const _hoisted_15 = /*#__PURE__*/_createElementVNode("span", null, "Preço", -1)
const _hoisted_16 = /*#__PURE__*/_createElementVNode("span", null, "Estoque", -1)
const _hoisted_17 = /*#__PURE__*/_createElementVNode("span", null, "Grupo", -1)
const _hoisted_18 = /*#__PURE__*/_createElementVNode("span", null, "Unidade", -1)
const _hoisted_19 = /*#__PURE__*/_createElementVNode("span", null, "Informação extra", -1)
const _hoisted_20 = {
  class: "modal-footer gap-2 p-0 pt-5",
  style: {"border":"none"}
}
const _hoisted_21 = /*#__PURE__*/_createElementVNode("span", null, "Esse processo vai apagar todos os produtos ja cadastrados, deseja mesmo continuar?", -1)
const _hoisted_22 = { class: "dialog-footer d-flex justify-content-end gap-3" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_tooltip = _resolveComponent("el-tooltip")!
  const _component_Button = _resolveComponent("Button")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _hoisted_7,
              _createElementVNode("span", _hoisted_8, _toDisplayString(_ctx.messageError), 1)
            ]),
            _hoisted_9
          ]),
          _createElementVNode("ul", _hoisted_10, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.productList, (item) => {
              return (_openBlock(), _createElementBlock("li", _hoisted_11, [
                _createElementVNode("div", null, [
                  _hoisted_12,
                  _createVNode(_component_el_input, {
                    modelValue: item.codProdutoLoja,
                    "onUpdate:modelValue": ($event: any) => ((item.codProdutoLoja) = $event),
                    class: _normalizeClass(item.validado === false ? 'naoValidado':'')
                  }, null, 8, ["modelValue", "onUpdate:modelValue", "class"]),
                  (item.validado === false)
                    ? (_openBlock(), _createBlock(_component_el_tooltip, {
                        key: 0,
                        class: "box-item",
                        effect: "dark",
                        content: "O código não está entre os produtos homologados! Para realizar o upload do produto, reajuste a planilha com os códigos corretos e tente novamente.",
                        placement: "right"
                      }, {
                        default: _withCtx(() => [
                          _hoisted_13
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true)
                ]),
                _createElementVNode("div", null, [
                  _hoisted_14,
                  _createVNode(_component_el_input, {
                    modelValue: item.produto,
                    "onUpdate:modelValue": ($event: any) => ((item.produto) = $event)
                  }, null, 8, ["modelValue", "onUpdate:modelValue"])
                ]),
                _createElementVNode("div", null, [
                  _hoisted_15,
                  _createVNode(_component_el_input, {
                    modelValue: item.preco,
                    "onUpdate:modelValue": ($event: any) => ((item.preco) = $event)
                  }, null, 8, ["modelValue", "onUpdate:modelValue"])
                ]),
                _createElementVNode("div", null, [
                  _hoisted_16,
                  _createVNode(_component_el_input, {
                    type: "number",
                    modelValue: item.estoque,
                    "onUpdate:modelValue": ($event: any) => ((item.estoque) = $event)
                  }, null, 8, ["modelValue", "onUpdate:modelValue"])
                ]),
                _createElementVNode("div", null, [
                  _hoisted_17,
                  _createVNode(_component_el_input, {
                    modelValue: item.grupoExibicao,
                    "onUpdate:modelValue": ($event: any) => ((item.grupoExibicao) = $event)
                  }, null, 8, ["modelValue", "onUpdate:modelValue"])
                ]),
                _createElementVNode("div", null, [
                  _hoisted_18,
                  _createVNode(_component_el_input, {
                    modelValue: item.unidade,
                    "onUpdate:modelValue": ($event: any) => ((item.unidade) = $event)
                  }, null, 8, ["modelValue", "onUpdate:modelValue"])
                ]),
                _createElementVNode("div", null, [
                  _hoisted_19,
                  _createVNode(_component_el_input, {
                    modelValue: item.informacao_extra,
                    "onUpdate:modelValue": ($event: any) => ((item.informacao_extra) = $event)
                  }, null, 8, ["modelValue", "onUpdate:modelValue"])
                ])
              ]))
            }), 256))
          ]),
          _createElementVNode("div", _hoisted_20, [
            _createVNode(_component_Button, {
              variant: "secondary",
              text: "Cadastrar Produtos",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.dialogVisible = true))
            })
          ])
        ])
      ])
    ]),
    _createVNode(_component_el_dialog, {
      modelValue: _ctx.dialogVisible,
      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.dialogVisible) = $event)),
      title: "Confirme sua ação",
      width: "30%"
    }, {
      footer: _withCtx(() => [
        _createElementVNode("span", _hoisted_22, [
          _createVNode(_component_Button, {
            type: "button",
            variant: "primary",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.dialogVisible = false))
          }, {
            default: _withCtx(() => [
              _createTextVNode("Cancelar")
            ]),
            _: 1
          }),
          _createVNode(_component_Button, {
            variant: "secondary",
            type: "button",
            onClick: _ctx.enviaPlanilha
          }, {
            default: _withCtx(() => [
              _createTextVNode("Continuar")
            ]),
            _: 1
          }, 8, ["onClick"])
        ])
      ]),
      default: _withCtx(() => [
        _hoisted_21
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}